module.exports = __webpack_public_path__ + "img/i_food.72b2885c.png";